import VueCookies from 'vue-cookies';
const DOMAIN = import.meta.env.VITE_DOMAIN;
const isHttps = window.location.protocol === 'https:';
let SameSite = isHttps ? 'None' : 'Lax';

VueCookies.config(null, '/', `.${DOMAIN}`, isHttps, SameSite);

export function getItem(key) {
  const item = VueCookies.get(key);
  return item;
}

export function setItem(key, value) {
  VueCookies.set(key, value);
}

export function removeItem(key, domain) {
  VueCookies.remove(key, '/', domain);
}

export function removeAll(domain) {
  VueCookies.keys().forEach((cookieName) => {
    VueCookies.remove(cookieName, '/', domain);
  });
}
